export default function fixedMenu() {

    var headerDOM = document.querySelector('.header__row');
    var header = document.querySelector('.header');
    var headerMenuDOM = document.querySelector('.menu--primary');
    var headerMenuLogoDOM = document.querySelector('.logo-container__main-logo');
    var headerMenuLogoColorDOM = document.querySelector('.logo-container__main-logo--color');
    var headerMenuLogoMobileDOM = document.querySelector('.logo-container--mobile__main-logo');
    var headerMenuLogoMobileColorDOM = document.querySelector('.logo-container--mobile__main-logo--color');
    var headerMenuSeparator = document.querySelector('.header__separator');
    var headerMenuSearch = document.querySelector('.header__search');
    var headerMenuContrast = document.querySelector('.header__contrast');
    var headerMenuLang = document.querySelector('.header__lang');
    var scroll = document.querySelector('.back-to-top');

    $(window).scroll(function(){
        const limit = 50;
        if ($(this).scrollTop()>=limit){
            scroll.classList.add('back-to-top--fixed');
            headerDOM.classList.add('header__row--fixed');
            header.classList.add('header--fixed');
            headerMenuDOM.classList.add('menu--primary-fixed');
            headerMenuLogoDOM.classList.add('logo-container__main-logo--fixed');
            headerMenuLogoColorDOM.classList.add('logo-container__main-logo--color--fixed');
            headerMenuLogoMobileDOM.classList.add('logo-container--mobile__main-logo--fixed');
            headerMenuLogoMobileColorDOM.classList.add('logo-container--mobile__main-logo--color--fixed');
        } else {
            scroll.classList.remove('back-to-top--fixed');
            headerDOM.classList.remove('header__row--fixed');
            header.classList.remove('header--fixed');
            headerMenuDOM.classList.remove('menu--primary-fixed');
            headerMenuLogoDOM.classList.remove('logo-container__main-logo--fixed');
            headerMenuLogoColorDOM.classList.remove('logo-container__main-logo--color--fixed');
            headerMenuLogoMobileDOM.classList.remove('logo-container--mobile__main-logo--fixed');
            headerMenuLogoMobileColorDOM.classList.remove('logo-container--mobile__main-logo--color--fixed');
        }
    });

}